import { error } from 'universal-logger';
import supportedLocaleKeys from 'locales/supported-locales.json';
import { makeDynamicDataLoader } from './factory';
import { REFRESH_INTERVAL, defaultLocaleData, supportedLocales } from './supported-locales.constants';

/**
 * We default to just the english locale since showing other locales could break the page
 * if those locales are expected to be disabled.
 * @param {Function} set sets values in dynamic data cache in './factory'
 * @param {Object} client
 */
const setLocales = (set, client) =>
  client.babelfish
    .getSupportedLocales()
    .then(data => {
      const updatedLocales = data
        .filter(locale => supportedLocaleKeys.includes(locale.use_language_tag))
        .map(locale => ({
          languageName: locale.language_name,
          localeKey: locale.use_language_tag,
        }));
      return set(updatedLocales);
    })
    .catch(err => {
      error('Dynamic Data: supported-locales: Failed to retrieve supported languages, falling back to defaults', err);
      return set([defaultLocaleData]);
    });

/**
 * If the feature flag fails, instead of defaulting to the static list, we default the locales to
 * be just english. This ensures no locales are shown that are intended to be disabled.
 */
export const { init, get, load } = makeDynamicDataLoader(
  'locales',
  (set, client) =>
    client.dash
      .getFeatureFlag('supported_languages_web')
      .then(isEnabled => (isEnabled ? setLocales(set, client) : set(supportedLocales)))
      .catch(err => {
        error('Dynamic Data: supported-locales: Failed to retrieve feature flag, falling back to defaults', err);
        return set([defaultLocaleData]);
      }),
  { refreshInterval: REFRESH_INTERVAL }
);
